import type { Tour } from "~/types/general";

export default async (tourSlug: string) =>
  useFetchWithCache<Tour>(
    import.meta.env.VITE_BASE_API_URL + `tour/${tourSlug}`
  );
